// [sc-49299] Anteprima del PDF prima del salvataggio: Nuovo e Modifica la
// costruiscono dai dati del form, il preventivo si salva solo se la si
// conferma. Gli importi seguono le stesse regole dell'API (prezzo ivato in
// utils/prezzoArticolo.js, totale articoli e percentuali in
// services/quote.service.js), così l'anteprima e il PDF dei dati salvati
// coincidono.

import { getCategoryGroup } from "./categorieArticolo";
import { prezzoBase, prezzoIvato } from "./prezzoArticolo";

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

/** Prezzo ivato della riga con la regola nuova (base = scontato o listino). */
export function prezzoIvatoRiga({ listPrice, discountedPrice, iva }) {
  return prezzoIvato(prezzoBase({ listPrice, discountedPrice }), iva ?? 22);
}

/**
 * Totale articoli come `totalPrice` dell'API: prezzo × quantità salvata
 * (scatole per le categorie a metro quadro o lineare, pezzi per le altre),
 * per mq o ml a scatola.
 * `righe`: { price, quantity, category, sqmPerBox, mlPerBox }.
 */
export function totaleArticoli(righe = []) {
  const somma = righe.reduce((t, r) => {
    const gruppo = getCategoryGroup(r.category);
    const perScatola =
      gruppo === "area"
        ? Number(r.sqmPerBox ?? 1)
        : gruppo === "linear"
        ? Number(r.mlPerBox ?? 1)
        : 1;
    return t + Number(r.price || 0) * Number(r.quantity || 0) * perScatola;
  }, 0);
  return round2(somma);
}

/**
 * Sconto e maggiorazione in percentuale seguono il totale articoli; quelli
 * in euro (percentuale 0) restano come sono. Come `importiDaPercentuali`
 * dell'API.
 */
export function importiDaPercentuali(totale, quote = {}) {
  const pctSconto = Number(quote.discount_percent) || 0;
  const pctRincaro = Number(quote.surcharge_percent) || 0;
  const base = Number(totale) || 0;
  return {
    discount:
      pctSconto > 0 ? round2((base * pctSconto) / 100) : quote.discount ?? 0,
    surcharge:
      pctRincaro > 0 ? round2((base * pctRincaro) / 100) : quote.surcharge ?? 0,
  };
}
